module.exports = __webpack_public_path__ + "img/mastercard.c9d5e09e.png";